var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":_vm.duracionContrato.nombre,"subtitle":"Duración de contrato","back-to":"/duracionesContrato"}}),_c('formulario',{attrs:{"duracion-contrato":_vm.duracionContrato},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }